import { FormControlLabel, Stack, Switch, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import {
  persistWeekStartsOnMondayPreference,
  readWeekStartsOnMondayPreference
} from "../utils/clientPreferences";

const ClientMiscForm = () => {
  const [weekStartsOnMonday, setWeekStartsOnMonday] = useState<boolean>(() =>
    readWeekStartsOnMondayPreference(true)
  );

  useEffect(() => {
    persistWeekStartsOnMondayPreference(weekStartsOnMonday);
  }, [weekStartsOnMonday]);

  return (
    <Stack spacing={2}>
      <Tooltip title="Switch weekday columns so Monday appears first in calendar heatmaps">
        <FormControlLabel
          control={
            <Switch
              checked={weekStartsOnMonday}
              onChange={(_, checked) => setWeekStartsOnMonday(checked)}
              name="weekStartsOnMonday"
            />
          }
          label="Week starts on Monday"
        />
      </Tooltip>
    </Stack>
  );
};

export default ClientMiscForm;
